import { render, staticRenderFns } from "./Attraction.vue?vue&type=template&id=0ce83081&scoped=true&"
import script from "./Attraction.vue?vue&type=script&lang=js&"
export * from "./Attraction.vue?vue&type=script&lang=js&"
import style0 from "./Attraction.vue?vue&type=style&index=0&id=0ce83081&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce83081",
  null
  
)

export default component.exports